import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast'; // Keep ToastModule in imports if Toast component is still in HTML (even if not actively used by TS)

import { TranslateService } from '../../../../../services/translate.service';
import { DirectionService } from '../../../../../services/direction.service';
import { CreateAccountService } from '../../create-account.service';

import { SelectItem } from '../../../../../models/selected-item.model';
@Component({
    selector: 'app-summary',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        ToastModule // Keep ToastModule if <p-toast> is in the HTML template
    ],
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {
    // Inputs from parent component (CreateAccountComponent) - two-way binding supported
    @Input() entityType: SelectItem | null = null;
    @Output() entityTypeChange = new EventEmitter<'Customer' | 'Supplier' | null>();

    @Input() businessName: string = '';
    @Output() businessNameChange = new EventEmitter<string>();

    @Input() businessNumber: string = '';
    @Output() businessNumberChange = new EventEmitter<string>();

    // Outputs to parent component for navigation or saving
    @Output() prevStep = new EventEmitter<void>();
    @Output() save = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    constructor(public translateServ :TranslateService, public dirServ : DirectionService, private createAccountService: CreateAccountService) {} 

    ngOnInit(): void {
        // Any initialization logic for the summary component
    }

    public completeProcess() : void
    {
        this.createAccountService.cleanMemory();
        this.save.emit();
    }

    public cancelProcess(): void
    {
        this.createAccountService.cleanMemory();
        this.cancel.emit();
    }
}